import { useEffect, useLayoutEffect, useRef } from 'react';
import { Dictionary } from '@direct-frontend/stdlib';

import { $internals, UnknownFormInstance } from '../form/types';

const TIMEOUT_TO_UNSUBSCRIBE = 300_000;

/** Создает подписку на данные формы */
export function useSubscription(instance: UnknownFormInstance) {
    const initializationId = instance[$internals].useFormInitializationId();
    // В качестве уникального ключа формы используем её name и id
    const instanceKey = `${instance.name}(${initializationId})`;
    const subscriptionsRef = useRef<Dictionary<Function>>({});

    // Подписываемся на изменения и сохраняем знание об этом в ref
    // Это позволяет не подписываться на одну и ту же форму дважды
    useLayoutEffect(() => {
        if (!subscriptionsRef.current[instanceKey]) {
            subscriptionsRef.current[instanceKey] = instance.subscribe();
        }
    }, [instance, instanceKey]);

    // Отписываемся только при анмаунте или изменении `instanceKey`
    // Это позволяет не терять подписку при изменении ссылки на форму
    useEffect(() => {
        const subscriptions = subscriptionsRef.current;

        return () => {
            const unsubscribe = subscriptions[instanceKey];
            delete subscriptions[instanceKey];

            setTimeout(() => {
                unsubscribe?.();
            }, TIMEOUT_TO_UNSUBSCRIBE);
        };
    }, [instanceKey]);
}
